import certificatesRedux from './reducer';

export default {
    certificatesRedux
};